import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { NEW_PASSWORD, FORGET_PASSWORD, UPDATE_PASSWORD } from "./actionTypes"
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  newPasswordSuccess,
  newPasswordError,
  updatePasswordSuccess,
  updatePasswordError,
} from "./actions"

import { AppConfiguration } from "config"

//Include Both Helper File with needed methods
import {
  postJwtForgetPwd,
  postJwtResetPwd,
  postJwtUpdatePwd
} from "../../../helpers/sf_backend_helper"


//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
      const response = yield call(
        postJwtForgetPwd,
        `${AppConfiguration.BACKEND_URL}/api/v1/password`,
        {
          email: user.email,
        }
      )
      if (response) {
        yield put(
          userForgetPasswordSuccess("Reset link is sent to your mailbox.")
        )
    } 
  } catch (error) {
    yield put(userForgetPasswordError(error))
  }
}

function* passwordReset({ payload: { user, history } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      const response = yield call(
        postJwtResetPwd,
        `${AppConfiguration.BACKEND_URL}/api/v1/password`,
        {
          email: user.email,
          reset_password_token: user.reset_password_token,
          password: user.password,
          password_confirmation: user.password_confirmation,
        }
      )
      yield put(newPasswordSuccess("Password Changed Successfully"))
    }
    history.push("/")
  } catch (error) {
    yield put(newPasswordError(error))
  }
}

function* passwordUpdate({ payload: { user } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")

      const response = yield call(
        postJwtUpdatePwd,
        `${AppConfiguration.BACKEND_URL}/api/v1/password`,
        {
          password: user.password,
          current_password: user.current_password,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(updatePasswordSuccess("Password Changed Successfully"))
    }
  } catch (error) {
    yield put(updatePasswordError(error))
  }
}

export function* watchresetPasswordSaga() {
  yield takeEvery(NEW_PASSWORD, passwordReset)
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

export function* watchupdatePasswordSaga() {
  yield takeEvery(UPDATE_PASSWORD, passwordUpdate)
}


function* resetPasswordSaga() {
  yield all([fork(watchresetPasswordSaga)])
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

function* updatePasswordSaga() {
  yield all([fork(watchupdatePasswordSaga)])
}

export { forgetPasswordSaga, resetPasswordSaga, updatePasswordSaga }
